import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';

import ToggleCard from './toggle-card.jsx';

const ThumbnailCard = ({thumbnail, children, sx, button = false, ...props}) => {
  return (
    <ToggleCard
      sx={{
        borderColor: props.selected ? 'primary.main' : 'grey.300',
        bgcolor: props.selected
          ? 'primary.lighter'
          : props.disabled
            ? 'action.disabledBackground'
            : 'grey.100',
        borderWidth: 2,
        position: 'relative',
        opacity: props.disabled ? 0.38 : 1,
        ...sx,
      }}
      button={button}
      {...props}
    >
      <Box padding={0.5} flexShrink={0} height="100%">
        {thumbnail}
      </Box>
      {children}
    </ToggleCard>
  );
};

ThumbnailCard.propTypes = {
  selected: PropTypes.bool,
  thumbnail: PropTypes.object.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
  button: PropTypes.bool,
};

export default ThumbnailCard;
